function isNumberKey(evt){
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}
function validateEmail(email) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (email.match(validRegex)) {
    return false;
  } else {
    return true;
  }
}

function sendData() {
  document.querySelector('#submit').setAttribute('disabled','disabled');
  let sheetUrl = 'https://script.google.com/macros/s/AKfycbz62kxUVgYfgUDWyDXvZuXwAGg2532cfqIMRl9QbN5szkkKHos5vGWfafb5vc_6y3ue/exec'
  let formData = {
    "Name": document.querySelector('#name').value.trim(),
    "Email": document.querySelector('#email').value.trim(),
    "Phone": document.querySelector('#phone').value,
  }
  request = $.ajax({
    url: sheetUrl,
    type: "post",
    data: formData
  })

  request.done(function(response, textStatus, jqXHR) {
    console.log(response);
    debugger
    document.querySelector('.event-form__form-wrapper').classList.add('done');
    window.location.href="https://soundscape.store/";
    
  })
  request.fail(function(){
    document.querySelector('#submit').removeAttribute('disabled');
    alert("Something Went wrong.Please try after sometime")
    
  })
  
}

document.querySelector('#submit').addEventListener('click', ()=>{
  if (document.querySelector('#name').value.trim().length == 0 ) {
    alert('Please enter Name');
    return false;
  } else if (validateEmail(document.querySelector('#email').value)) {
    alert('Please enter valid Email');
    return false;
  } else if (document.querySelector('#phone').value.length < 10) {
    alert('Please enter valid phone number');
    return false;
  } else {
    sendData();    
  }
});